import { render } from "./serviceuser.vue?vue&type=template&id=2f076a7e"
import script from "./serviceuser.vue?vue&type=script&lang=js"
export * from "./serviceuser.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__